import { ManualGasXTransfertStatus } from '@core/models/manual-gasx-transfert.model';
import { SimulationType } from '@core/models/simulation-metadata.model';
import { fromCore } from '@core/store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { State, exportGasXFeatureKey } from './export-gasx.reducer';

const selectExportGasXState = createFeatureSelector<State>(exportGasXFeatureKey);

// Raw selectors

export const getManualGasXTransfert = createSelector(
  selectExportGasXState,
  (state: State) => state.manualGasXTransfert
);

export const getSelectionMode = createSelector(selectExportGasXState, (state: State) => state.selectionMode);

export const getSelectedObjects = createSelector(selectExportGasXState, (state: State) => state.selectedObjects);

// Calculated selectors

export const getSimulationDateRange = createSelector(fromCore.getLatestSimulations, simulations => {
  const hreko = simulations && simulations.find(s => s.simulationResult.simulationType === SimulationType.HREKO);
  if (hreko) {
    return {
      min: DateTime.fromISO(hreko.min),
      max: DateTime.fromISO(hreko.max)
    };
  }
});

export const getLastRecomputeDateRange = createSelector(fromCore.getLatestSimulations, simulations => {
  const mreko = simulations && simulations.find(s => s.simulationResult.simulationType === SimulationType.MREKO);
  if (mreko) {
    return {
      min: DateTime.fromISO(mreko.simulationResult.startInterval),
      max: DateTime.fromISO(mreko.simulationResult.endInterval)
    };
  }
});

export const hasManualGasXTransfertRunning = createSelector(
  getManualGasXTransfert,
  manualGasXTransfert =>
    !!manualGasXTransfert &&
    manualGasXTransfert.status !== ManualGasXTransfertStatus.DONE &&
    manualGasXTransfert.status !== ManualGasXTransfertStatus.ERROR &&
    manualGasXTransfert.status !== ManualGasXTransfertStatus.CANCELED
);

export const getSelectedObjectsCount = createSelector(getSelectedObjects, selectedObjects => selectedObjects.length);

export const canValidManualGasXTransfert = createSelector(
  getSelectionMode,
  getSelectedObjects,
  (selectionMode, selectedObjects) =>
    selectionMode !== null && (selectionMode !== 'CUSTOM' || selectedObjects.length > 0)
);
